'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * extract nested-hateoas model from hateoasModel and render `view` with attribute `model` equal fetched model
 * @deprecated use `WithModel`
 */
var HateoasModelView = function (_Component) {
  _inherits(HateoasModelView, _Component);

  function HateoasModelView() {
    _classCallCheck(this, HateoasModelView);

    return _possibleConstructorReturn(this, (HateoasModelView.__proto__ || Object.getPrototypeOf(HateoasModelView)).apply(this, arguments));
  }

  _createClass(HateoasModelView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          modelClass = _props.modelClass,
          modelId = _props.modelId;

      this._fetchModel(modelClass, modelId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          View = _props2.view,
          additionalProps = _props2.additionalProps;
      var model = this.state.model;


      return _react2.default.createElement(View, _extends({}, additionalProps, {
        model: model,
        modelBackendSyncState: model.getBackendSyncState()
      }));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props3 = this.props,
          modelClass = _props3.modelClass,
          modelId = _props3.modelId;


      if (nextProps.modelClass === modelClass && nextProps.modelId === modelId) {
        return;
      }

      this._fetchModel(modelClass, modelId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._onDeinit && this._onDeinit();
    }
  }, {
    key: '_fetchModel',
    value: function _fetchModel(modelClass, modelId) {
      var _this2 = this;

      var model = modelClass.domain.getCache().getEntity(modelClass.hateoasType, modelId);

      this.setState({ model: model });

      var readiness = this.context.readiness;


      if (readiness) {
        this._onDeinit && this._onDeinit();
        readiness.unready(this);
        var ready = function ready() {
          return readiness.ready(_this2);
        };
        model.on(model.triggerWhenChanged, ready);
        this._onDeinit = function () {
          model.off(model.triggerWhenChanged, ready);
        };
      }
    }
  }]);

  return HateoasModelView;
}(_react.Component);

HateoasModelView.contextTypes = {
  readiness: _propTypes2.default.object
};
HateoasModelView.propTypes = {
  modelClass: _propTypes2.default.func.isRequired,
  modelId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  view: _propTypes2.default.func.isRequired,
  additionalProps: _propTypes2.default.object
};
HateoasModelView.defaultProps = {
  additionalProps: {}
};
exports.default = HateoasModelView;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/HateoasModelView.js
// module id = 1300
// module chunks = 118